import { LABEL_ADD_TO_BASKET_VISIBLE } from "./constants";
import { findLabelByKey } from "../utils/internal";
export var mapCanBeSold = function mapCanBeSold(labels) {
  return (labels === null || labels === void 0 ? void 0 : labels.find(findLabelByKey(LABEL_ADD_TO_BASKET_VISIBLE))) !== undefined;
};
//# sourceMappingURL=mapCanBeSold.js.map